export default __webpack_public_path__ + "routing-500-76734d1c858762ad0e49b2cb95e3b394.png";